import API from "utils/API";
import authHeader from "utils/auth-header";
import { IGetRequisitionsResponse } from "../domain/IGetRequisitionsResponse";
import { IRequisition } from "../domain/IRequisition";
import { IGetScrollDataRequestParams } from "Dashboard/scenes/Chat/domain/IGetScrollDataRequestParams";
import { getQeuryParams } from "utils/queryParamsUtil";
import { IGetPageRequestParams } from "hooks/pagingAndSort";
import { IGetRequisitionsRequestParams } from "../domain/IGetRequisitionsRequestParams";

const getAllRequsitions = async (
  params: IGetScrollDataRequestParams,
  signal: AbortSignal
): Promise<IRequisition[]> => {
  var headers = authHeader();
  try {
    const { filter, ...rest } = params;
    const queryParamsObject = filter !== undefined ? { ...rest, ...filter } : rest;
    const response = await API.get<IGetRequisitionsResponse>(
      `/requisitions/protected/requisition${getQeuryParams(queryParamsObject)}`,
      { headers, signal }
    );
    let requisitions = response.data.requisitions;
    return requisitions;
  } catch (err) {
    throw err;
  }
};

const getAllRequsitionsV2 = async (
  getRequisitionsRequestParams: IGetRequisitionsRequestParams,
  pagingData: IGetPageRequestParams,
  signal: AbortSignal
): Promise<IRequisition[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetRequisitionsResponse>(
      `/requisitions/protected/requisition${getQeuryParams({ ...getRequisitionsRequestParams, ...pagingData })}`,
      { headers, signal }
    );
    let requisitions = response.data.requisitions;
    return requisitions;
  } catch (err) {
    throw err;
  }
};

const acceptRequisition = async (
  requisitionId: number
): Promise<IRequisition> => {
  var headers = authHeader();
  try {
    const response = await API.put<IRequisition>(
      `/requisition-execution/protected/requisition/${requisitionId}/accept`,
      {},
      { headers }
    );
    let requisition = response.data;
    return requisition;
  } catch (err) {
    throw err;
  }
};

const replyToRequisition = async (
  requisitionId: number, replyText: string
): Promise<IRequisition> => {
  var headers = authHeader();
  try {
    const response = await API.put<IRequisition>(
      `/requisition-execution/protected/requisition/${requisitionId}/reply`,
      { replyText },
      { headers }
    );
    let requisition = response.data;
    return requisition;
  } catch (err) {
    throw err;
  }
}

export const requisitionsService = {
  getAllRequsitions,
  getAllRequsitionsV2,
  acceptRequisition,
  replyToRequisition,
};
